import type { Alpine } from "alpinejs";
import intersect from "@alpinejs/intersect";
import collapse from "@alpinejs/collapse";
import { PUBLIC_PAYLOAD_URL } from "astro:env/client";
import { initLoadMoreButtons } from "./utils/loadMore";

export default (Alpine: Alpine) => {
  Alpine.plugin(intersect);
  Alpine.plugin(collapse);

  type ModalStore = {
    isOpen: boolean;
    toggle: () => void;
    close: () => void;
    open: () => void;
    resetFormState: () => void;
    attachOpenHandler: () => void;
  };

  Alpine.store("modal", {
    isOpen: false,

    init() {
      document.addEventListener(
        "astro:page-load",
        this.attachOpenHandler.bind(this),
      );
    },
    toggle() {
      this.isOpen = !this.isOpen;
      setTimeout(() => this.resetFormState(), 500);
    },
    close() {
      this.isOpen = false;
      setTimeout(() => this.resetFormState(), 500);
    },
    open() {
      this.isOpen = true;
      setTimeout(() => this.resetFormState(), 500);
    },
    resetFormState() {
      window.dispatchEvent(new CustomEvent("reset-form"));
    },
    attachOpenHandler() {
      const openButton = document.getElementById("open-contact-form");
      if (openButton) {
        openButton.addEventListener("click", (event) => {
          event.preventDefault();
          this.isOpen = true;
        });
      }

      const footerButton = document.getElementById("contact-now-footer");
      if (footerButton) {
        footerButton.addEventListener("click", (event) => {
          event.preventDefault();
          this.isOpen = true;
        });
      }
    },
  } as ModalStore);

  // Initialize load more functionality
  document.addEventListener("astro:page-load", () => {
    initLoadMoreButtons();
  });

  Alpine.data("useForm", () => ({
    response: false,
    isSuceess: false,
    isError: false,

    init() {
      window.addEventListener("reset-form", this.reset.bind(this));
    },

    reset() {
      this.response = false;
      this.isSuceess = false;
      this.isError = false;
    },

    data() {
      const inputs = Array.from(
        this.$el.querySelectorAll("input, textarea"),
      ) as Array<HTMLInputElement | HTMLTextAreaElement>;

      const data = inputs.reduce(
        (list, input) => {
          if (input instanceof HTMLInputElement && input.type === "checkbox") {
            return [...list, { field: input.name, value: input.checked }];
          } else {
            return [...list, { field: input.name, value: input.value }];
          }
        },
        [] as Array<{ field: string; value: string | boolean }>,
      );

      return data;
    },

    async post() {
      this.isSuceess = false;
      this.isError = false;

      const submissionData = this.data();

      const privacyCheck = submissionData.find(
        (item) => item.field === "privacy_check",
      );

      if (!privacyCheck || privacyCheck.value !== true) {
        alert("Bitte bestätigen Sie den datenschutzrechtlichen Hinweis.");
        return;
      }

      try {
        const response = await fetch(
          `${PUBLIC_PAYLOAD_URL}/api/form-submissions`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              form: 1,
              submissionData,
            }),
          },
        );

        this.response = await response.json();

        if (response.ok) {
          this.isSuceess = true;
        } else {
          this.isError = true;
        }
      } catch (error) {
        this.isError = true;
      }
    },
  }));
};
